import React, { useState, useRef } from 'react'

// component
import { Skeleton } from '../../../../components/Skeleton'
import { ListInboxPublications } from './ListInboxPublications'

// api
import { useInboxesOfUserQuery } from '../../../../requests/inboxMembers'

// hooks
import { useInView } from '../../../../hooks/useInView'

type Props = {
  userId: string
}

export const ListUserInboxes: React.FC<Props> = ({ userId }) => {
  const [isInView, setIsInView] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)

  const { data: userInboxes = [], isLoading: loading } = useInboxesOfUserQuery(
    userId,
    {
      enabled: isInView, // Only fetch when component is in view
    }
  )

  useInView(containerRef, {
    rootMargin: '50px',
    triggerOnce: true,
    onIntersect: () => setIsInView(true)
  })

  return (
    <div ref={containerRef}>
      {loading ? (
        <p>
          <Skeleton width={70} />
          <Skeleton width={40} />
        </p>
      ) : !userInboxes.length ? (
        <p>No inboxes</p>
      ) : (
        <p>
          {userInboxes
            .filter((userInbox) => userInbox.inbox)
            .map((userInbox) => (
              <ListInboxPublications key={userInbox.inbox!._id} inbox={userInbox.inbox!} />
            ))}
        </p>
      )}
    </div>
  )
}
